// For expandable content / text

window.addEventListener('load', () => {
    const loadMoreButton = document.querySelectorAll('.show-more-text-button');
    if (loadMoreButton.length) {
        let largeHeight = 0;
        let smallHeight = 0;

        loadMoreButton.forEach((element) => {
            element.addEventListener('click', function (event) {
                let target = event.target;
                let targetParent = target.closest('section')
                let finalHeight = (largeHeight - smallHeight) * -1;

                if (element.querySelector('span').innerHTML !== element.querySelector('span').dataset.lessText) {
                    element.querySelector('span').innerHTML = element.querySelector('span').dataset.lessText;
                    smallHeight = targetParent.offsetHeight;
                } else {
                    element.querySelector('span').innerHTML = element.querySelector('span').dataset.moreText;
                    document.querySelector('html').style.scrollBehavior = 'auto';
                    largeHeight = targetParent.offsetHeight;
                    finalHeight = (largeHeight - smallHeight) * -1;
                    window.scrollBy(0, finalHeight);
                    document.querySelector('html').style.scrollBehavior = 'smooth';
                }

                let arrows = element.querySelectorAll('.show-more-text-arrow');
                for (let arrow of arrows) {
                    let svg = element.querySelector('svg');
                    if(svg) {
                       svg.classList.toggle('-rotate-180');
                    }
                }

                let showHideContentContainer = element.closest('.show-hide-text-container');
                const hiddenContent = showHideContentContainer.querySelectorAll('.hidden-content');
                hiddenContent.forEach(ele => {
                    ele.classList.toggle('hidden');
                });
            });
        });
    }
});